import React, { useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { LARGO, mensajeLargo } from "consts/limites-campos";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHZonaIns } from "services/services-mia/programa-salud/estructuras/RNHZonaIns";

export default function InsertModal({ updateList, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const formikRef = useRef();

    const handleCreateZona = async (values) => {
        const response = await RNHZonaIns(
            credentials,
            { 
                name: values.nombre, 
                cod: values.cod,
                wkt: values.wkt
            }
        );
        if (response.ok) {
            setSnackBarInfo({
                message: "Zona creada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    }
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
                cod: "",
                wkt: ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(LARGO.nombre, mensajeLargo(LARGO.nombre)).required("Debe ingresar un nombre"),
                    cod: yup.string("Debe ingresar un código").max(LARGO.cod, mensajeLargo(LARGO.cod)).required("Debe ingresar un código"),
                })
            }
            onSubmit={(values) => {
                handleCreateZona(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                        <Grid
                          container
                          rowSpacing={0}
                          columnSpacing={2}
                          sx={{
                            width: "100%",
                            "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
                          }}
                        >
                          <Grid item xs={4}>
                            <FormikTextInput
                                fullWidth={true}
                                name="cod"
                                labelText="Código"
                                inputProps={{ maxLength: LARGO.cod }}
                            />
                          </Grid>
                          <Grid item xs={8}>
                            <FormikTextInput
                                fullWidth={true}
                                name="nombre"
                                labelText="Nombre"
                                inputProps={{ maxLength: LARGO.nombre }}
                            />
                          </Grid>
                        </Grid>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Crear" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest) && <SpinnerOverlay />}
                </div>
            </Form>
        </Formik>
    );
}
